<template>
    <div class="main">
        <el-form
            :model="formModel"
            label-width="80px"
            label-position="right"
            :rules="rules"
            ref="form"
        >
            <el-form-item label="订单号">
                <el-input
                    v-model="formModel.orderNumber"
                    style="width: 80%"
                    disabled
                ></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="customerName">
                <el-input
                    v-model="formModel.customerName"
                    style="width: 80%"
                    disabled
                ></el-input>
            </el-form-item>
            <el-form-item label="餐饮类型" prop="orderType">
                <el-checkbox-group
                    v-model="formModel.orderType"
                    style="width: 80%"
                    disabled
                >
                    <el-checkbox label="1">早餐</el-checkbox>
                    <el-checkbox label="2">午餐</el-checkbox>
                    <el-checkbox label="3">晚餐</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item label="取餐方式" prop="takeWay">
                <el-radio v-model="formModel.takeWay" label="0" disabled
                    >送餐</el-radio
                >
                <el-radio v-model="formModel.takeWay" label="1" disabled
                    >堂食</el-radio
                >
                <el-radio v-model="formModel.takeWay" label="2" disabled
                    >自取</el-radio
                >
            </el-form-item>
            <el-form-item
                label="送餐人员"
                prop="personName"
                v-if="formModel.takeWay == 0"
            >
                <el-input
                    v-model="formModel.personName"
                    disabled
                    style="width: 80%"
                ></el-input>
            </el-form-item>
            <el-form-item
                label="结束时间"
                v-if="formModel.takeWay == 0"
                prop="deliveryEndTime"
            >
                <el-date-picker
                    style="width: 80%"
                    v-model="formModel.deliveryEndTime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="请选择结束时间"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="附件" v-if="formModel.takeWay == 0">
                <el-upload
                    class="avatar-uploader"
                    :action="actionUrl"
                    :show-file-list="false"
                    :on-success="uploadSuccess"
                >
                    <img
                        v-if="formModel.annex"
                        :src="formModel.annex"
                        class="avatar"
                    />
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import baseURL from "@/api/baseURL"

export default {
    props: ["openData", "datas"],
    data() {
        return {
            actionUrl:
                baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
            formModel: {
                orderNumber: "",
                customerName: "",
                orderType: [],
                takeWay: "",
                personName: "",
                deliveryEndTime: "", //结束时间,
                annex: "",
            },
            rules: {
                // customerName: [
                //   { required: true, message: "请输入姓名", trigger: "blur" },
                // ],
                // orderType: [
                //   { required: true, message: "请选择餐饮类型", trigger: "change" },
                // ],
                // takeWay: [
                //   { required: true, message: "请选择取餐方式", trigger: "change" },
                // ],
                // personName: [
                //   { required: true, message: "请输入送餐人员", trigger: "blur" },
                // ],
                deliveryEndTime: [
                    {
                        required: true,
                        message: "请选择时间",
                        trigger: "change",
                    },
                ],
            },
        }
    },
    methods: {
        uploadSuccess({ content }) {
            //let url = `${content}`.replace(/36.33.216.70/, "192.168.1.138") //线上环境注释掉
            this.formModel.annex = url
        },
        checkData() {
            if (this.formModel.takeWay == 0) {
                let flag = false
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        this.$emit("update:datas", { ...this.formModel })
                        flag = valid
                    }
                })
                return flag
            }
            return true
        },
    },
    mounted() {
        let { orderType } = this.openData.data
        this.formModel = {
            ...this.openData.data,
            orderType: orderType.split(","),
        }
    },
}
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
.content {
    padding: 0 60px;
    width: 400px;
    margin: auto;
}
.itemContent {
    display: flex;
    line-height: 34px;
    margin-bottom: 24px;
    .name {
        width: 120px;
    }
    .boxs {
        flex: 1;
        width: 0;
    }
}
/deep/.avatar-uploader-icon {
    width: 148px;
    height: 148px;
    line-height: 148px;
}
</style>